<template>
  <div class="mainAuxPage zj-flex-column">

    <zj-card class="pageheader" block>
      <div class="zj-flex-row">
        <div class="left-content">
          <el-avatar :size="45">{{ CurrentAccountInfo.emp_name }}</el-avatar>
          <div class="content-msg">
            <div class="msg" v-if="4 <= currentDate.getHours() && currentDate.getHours() < 9">
              用心把握每一环节</div>
            <div class="msg" v-if="9 <= currentDate.getHours() && currentDate.getHours() < 12">
              早上好，{{ CurrentAccountInfo.emp_name }}，欢迎您使用数智IE服务系统！</div>
            <div class="msg" v-if="12 <= currentDate.getHours() && currentDate.getHours() < 18">
              下午好，{{ CurrentAccountInfo.emp_name }}，欢迎您使用数智IE服务系统！</div>
            <div class="msg" v-if="18 <= currentDate.getHours() && currentDate.getHours() < 22">
              晚上好，{{ CurrentAccountInfo.emp_name }}，欢迎您使用数智IE服务系统！</div>
            <div class="msg" v-if="22 <= currentDate.getHours() || currentDate.getHours() < 4">
              夜深了，{{ CurrentAccountInfo.emp_name }}，欢迎您使用数智IE服务系统，早点休息！</div>
          </div>
        </div>
        <div class="right-content">
          <div class="content-item">
            <div class="title" style="color:red; font-size :22px;"> 学而不知足，自强而争先</div>
            <!-- <div class="tip" @click="bindWX">绑定微信</div> -->
            <!-- <div class="title-content">{{projectList.length}}</div> -->
          </div>
        </div>
      </div>
    </zj-card>

    <div class="zj-flex-row">
      <div class="zj-flex-column" style="flex:0.25">
        <zj-card class="projectDiv">
          <div slot="header">
            <div style="display: flex;flex: 1;flex-direction: row;justify-content: space-between;">
              <div style="display: flex;align-items: center;">
                <div>热点通知</div>
              </div>
              <!-- <div style="display: flex;flex-direction: row;" v-if="isDeveloper">
                <el-button size="mini" type="primary" icon="el-icon-plus" circle @click="changeStatus(4)"></el-button>
                <el-button v-if="!editStatus" size="mini" type="primary" icon="el-icon-edit" circle
                  @click="changeStatus(0)"></el-button>
                <el-button v-if="editStatus" size="mini" type="success" icon="el-icon-edit" circle
                  @click="changeStatus(1)"></el-button>
                <el-button v-if="!sortStatus" size="mini" type="primary" icon="el-icon-sort" circle
                  @click="changeStatus(2)"></el-button>
                <el-button v-if="sortStatus" size="mini" type="success" icon="el-icon-sort" circle
                  @click="changeStatus(3)"></el-button>
              </div> -->
            </div>
          </div>
          <div class="zj-flex-column" ref="projectTable" v-if="notificationShow">
            <div v-for="(item, index) in notificationData" :draggable="true" @dragstart="dragstart(index)"
              @dragenter="dragenter($event, index)" @dragover="dragover($event, index)" @click="addOrEdit(0, item)">
              <div class="projectCard" @click="openWindow(item.notification_link)">
                <div class="projectCardHead">
                  <span style="margin-right:5px;display:-webkit-box;font-size:19px;">{{ item.notification_head }}</span>
                </div>
                <div style="display:flex;">
                  <div class="rightTable">
                    <table style="font-size:13px;width:100%;">
                      <div v-for="lineNum in item.line">
                        <div style="display: flex;flex:1;flex-direction: row;flex-wrap: wrap;">
                          <div v-for="subItem in item.content">
                            <div v-if="subItem.nc_line == lineNum" style="margin-right: 10px;">
                              <tr height='30px;'>
                                <th style="width: auto;white-space: nowrap;">{{ subItem.nc_title }}：</th>
                                <td>{{ subItem.nc_content }}</td>
                              </tr>
                            </div>
                          </div>
                        </div>
                      </div>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div>

            </div>
            <!-- <zj-empty v-else></zj-empty> -->
          </div>
        </zj-card>

      </div>
      <div class="zj-flex-column">
        <div class="zj-flex-column">
          <div class="reachPanel zj-flex-row">
            <zj-card style="flex:1;  margin-right: 5px;">
              <div slot="header">
                <span>赛事大厅</span>

                <el-input size="small" v-model="model" @keyup.enter.native="refreshGame"  placeholder="请输入大赛名称"
                  clearable style="width:300px;">

                  <el-button size="small"  @click="refreshGame"  slot="append"  icon="el-icon-search">搜索</el-button>
                </el-input>
                <el-button icon="el-icon-refresh" title="刷新" size="mini" circle @click="refreshGame">
                </el-button>
                <el-button icon="el-icon-right" title="查看详情" size="mini" circle
                  @click="changRouter('competition/gameRegistration')">
                </el-button>
              </div>

              <zj-table ref="projectTable" :data="tableData" row-key="project_id" border tooltip-effect="dark" stripe
                highlight-current-row height="100%">
                <el-table-column type="index"  width="35"  align="center"  label="序号"></el-table-column>
                <el-table-column prop="p_name"  label="大赛名称"  align="center" width="200"></el-table-column>
                <el-table-column label="报名开始日期" prop="competition_startdate" align="center">
                  <template slot-scope="scope">{{ scope.row.competition_startdate | dateFilter() }}</template>
                </el-table-column>
                <el-table-column label="报名结束日期" prop="competition_enddate" align="center">
                  <template slot-scope="scope">{{ scope.row.competition_enddate | dateFilter() }}</template>
                </el-table-column>
                <el-table-column prop="p_status" label="大赛进程" align="center" sortable>
                  <template slot-scope="scope">
                    <div v-if="new Date(scope.row.competition_startdate).getTime() > new Date().getTime()"
                      class="process1">
                      未开始
                    </div>
                    <div
                      v-if="new Date(scope.row.competition_startdate).getTime() < new Date().getTime() && new Date(scope.row.competition_enddate).getTime() > new Date().getTime()"
                      class="process2">
                      正在报名
                    </div>
                    <div v-if="new Date(scope.row.competition_enddate).getTime() < new Date().getTime()" class="process3">
                      报名截止
                    </div>
                  </template>
                </el-table-column>

              </zj-table>

            </zj-card>
            <zj-card style="flex:1;  margin-right: 5px;">
              <div slot="header">
                <span>我的比赛</span>
                <el-input size="small" v-model="condition" @keyup.enter.native="searchData"  placeholder="请输入大赛名称"
                  clearable style="width:300px;">
                  <el-button size="small" slot="append" icon="el-icon-search" @click="searchData">查询</el-button>
                </el-input>
                <el-button icon="el-icon-refresh" title="刷新" size="mini" @click="searchData" circle></el-button>

                <el-button icon="el-icon-right" title="查看详情" size="mini" circle
                  @click="changRouter('competition/resultQuery')">
                </el-button>
              </div>
              <div class="zj-table-ct">
                <el-table :data="tabelDatas" border tooltip-effect="dark" highlight-current-row>
                  <el-table-column type="index"  width="35"  align="center"  label="序号"></el-table-column>
                  <el-table-column prop="p_name" label="大赛名称" align="center"></el-table-column>
                  <el-table-column prop="ct_code" label="队伍编号" align="center"></el-table-column>
                  <el-table-column prop="ct_name" label="队伍名称" align="center"></el-table-column>

                  <zj-table-column prop="ct_stage" label="当前状态" align="center" width="80" :dict="dict"></zj-table-column>
                  <zj-table-column prop="ct_grade" label="荣获奖项" align="center" width="80" :dict="dict"></zj-table-column>

                </el-table>

              </div>

            </zj-card>

          </div>
          <div class="chartPanel zj-flex-row" style=" height: 100px;">

            <zj-card style="flex:1; margin-top: 5px; margin-right: 5px;">
              <div slot="header">
                <span>我的课程</span>
                <!-- <el-input size="small" v-model="course" @keyup.enter.native="getcourse"  placeholder="请输入课程名称" clearable style="width:300px;">
                  <el-button size="small" slot="append" icon="el-icon-search" @click="getcourse">查询</el-button>
                  </el-input> -->
                <el-button icon="el-icon-refresh" title="刷新" size="mini" @click="getcourse" circle></el-button>

                <el-button icon="el-icon-right" title="请打开知学习小程序查看" size="mini" @click="open" circle>
                </el-button>
              </div>

              <zj-table :data="courseDatas" border tooltip-effect="dark" highlight-current-ro>
                <el-table-column type="index"  width="35"  align="center"  label="序号"></el-table-column>
                <el-table-column prop="p_no" label="课程编号" align="center"></el-table-column>
                <el-table-column prop="p_name" label="课程名称" align="center"></el-table-column>

                <el-table-column prop="emp_name" label="课程老师" align="center">

                </el-table-column>

                </el-table-column>

              </zj-table>

            </zj-card>
            <zj-card style="flex:1; margin-top: 5px; margin-right: 5px;">
              <div slot="header">
                <span>课程签到</span>
                <el-input size="small" v-model="sign" @keyup.enter.native="getsign"  placeholder="请输入课程名称"
                  clearable style="width:300px;">
                  <el-button size="small" slot="append" icon="el-icon-search" @click="getsign">查询</el-button>
                </el-input>
                <el-button icon="el-icon-refresh" title="刷新" size="mini" @click="getsign" circle></el-button>

                <el-button icon="el-icon-right" title="请打开知学习小程序查看" size="mini" @click="open" circle>
                </el-button>
              </div>

              <zj-table :data="signDatas" border tooltip-effect="dark" highlight-current-row>

                <el-table-column prop="p_name" label="课程名称" align="center" width="100"
                  show-overflow-tooltip></el-table-column>
                <el-table-column prop="pp_location" label="地点" align="center" width="100"
                  show-overflow-tooltip></el-table-column>

                <el-table-column prop="sp_startdt" label="签到开始时间" align="center" sortable>
                  <template slot-scope="scope">
                    {{ scope.row.sp_startdt | dateFilter('MM-dd HH:mm') }}
                  </template>
                </el-table-column>

                <el-table-column prop="sp_enddt" label="签到结束时间" align="center" sortable>
                  <template slot-scope="scope">
                    {{ scope.row.sp_enddt | dateFilter('MM-dd HH:mm') }}
                  </template>
                </el-table-column>

              </zj-table>

            </zj-card>
          </div>
        </div>
      </div>
      <el-dialog v-dialogDrag width="450px" title="二维码绑定" :visible.sync="qrVisible" :close-on-click-modal="false"
        append-to-body>
        <template>
          <!-- <img class="half-png" src="assets/img/web-half.png" @click="tabClick('password')" /> -->
          <div style="height:400px">
            <div class="image-div">
              <img class="center-png" src="assets/logo/logo_circle.png" />
            </div>
            <div class="qrcode-ct">
              <div @click="getQrCodeByBind">
                <vue-qr :text="qr_src" binarize :size="200" :margin="10" style="border: 1px solid #eee"></vue-qr>
                <!-- <vue-qr :text="qr_src" :size="200" :margin="10" style="border: 1px solid #eee"></vue-qr> -->
              </div>
              <div class="qr-tip">{{ qr_tip }}</div>
            </div>
          </div>

        </template>
      </el-dialog>
      <editNotifucation ref="editNotifucation" :visible.sync="editVisible" :editType="editType">
      </editNotifucation>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import vueQr from 'vue-qr';
import editNotifucation from './editNotifucation.vue';

export default {
  components: {
    vueQr,
    editNotifucation
  },

  data() {
    return {
      ischeck: false,
      timer: null,
      openid: '',
      qr_code: "",
      qr_over_due: true,
      qr_src: '',
      qr_tip: '',
      qrVisible: false,
      op_date: new Date().getDayStart(),
      pes_time: new Date().getDayStart(),
      record_date: new Date().getDayStart(),
      dict: [],
      sign: '',
      signDatas: [],
      condition: "",
      courseDatas: [],
      projectList: [],
      projectDict: [],
      doTaskData: [],
      course: '',
      doTaskDataDict: [],
      activeName: 'first',
      currentDate: new Date(),
      CurrentAccountInfo: { emp_name: "1122" },
      tableDatas1: [],
      tableData: [],
      tableDatas2: [],
      model: '',
      model1: '',
      tabelDatas: [],
      tableDatas3: [],
      Order5dayList: [],
      activetitle: ['日期'],
      chartData: {
        columns: ['日期', '访问用户'],
        rows: [
          { '日期': '1/1', '访问用户': 1393 },
          { '日期': '1/2', '访问用户': 3530 },
          { '日期': '1/3', '访问用户': 2923 },
          { '日期': '1/4', '访问用户': 1723 },
          { '日期': '1/5', '访问用户': 3792 },
          { '日期': '1/6', '访问用户': 4593 }
        ]
      },
      LineData: {
        columns: ['日期', 'AUSU', 'A0001', 'P0002'],
        rows: [
          { '日期': '1/1', 'AUSU': 0.32, 'A0001': 0.8, 'P0002': 0.32 },
          { '日期': '1/2', 'AUSU': 0.32, 'A0001': 0.8, 'P0002': 0.26 },
          { '日期': '1/3', 'AUSU': 0.32, 'A0001': 0.8, 'P0002': 0.76 },
          { '日期': '1/4', 'AUSU': 0.32, 'A0001': 0.8, 'P0002': 0.49 },
          { '日期': '1/5', 'AUSU': 0.32, 'A0001': 0.8, 'P0002': 0.323 },
          { '日期': '1/6', 'AUSU': 0.32, 'A0001': 0.8, 'P0002': 0.78 }
        ]
      },
      notificationData: [],
      dragIndex: '',
      enterIndex: '',
      timeout: null,
      editVisible: false,
      editType: 1,
      editStatus: false,
      sortStatus: false,
      isDeveloper: false,
      notificationShow: false
    };
  },
  computed: {
    ...mapState(["accountInfo"]),
  },
  methods: {
    bindWX() {
      this.qrVisible = true;
      this.qr_over_due = true;
      this.getQrCodeByBind();


    },
    getQrCodeByBind() {

      if (this.qr_over_due) {
        if (this.timer != null) {
          clearInterval(this.timer);
        }
        this.z_post("api/scan/generateCode", {

        }, {
          params: {
            client_id: this.getBrowserClientId(),
            type: "bind",
            origin: window.location.origin
          }
        }).then(res => {
          this.qr_src = res.data.url;

          //  this.qr_src = "data:image/png;base64," + res.data.url;//网页端调试
          this.qr_code = res.data.code;
          this.qr_over_due = false;
          this.qr_tip = "请用微信扫码绑定";
          //这里应该由确认登录后才调用

          this.timer = setInterval(() => {
            if (this.ischeck == false) {

              this.ischeck = true;
              this.z_get("api/scan/CheckQrStatus", {
                code: this.qr_code,
                scanType: 'bind'
              }).then(r => {

                this.ischeck = false;
                if (r.data.status == 10) {
                  this.qr_tip = "扫描成功，等待确认";
                  this.qr_over_due = true;
                } else if (r.data.status == 20) {
                  this.qr_tip = "绑定成功";
                  this.postBindWX(r.data.wx_openid, r.data.wx_unionid);
                  clearInterval(this.timer);
                  // window.localStorage.setItem("AccountInfo", JSON.stringify({
                  //   token: r.data.token,
                  //   company: { c_id: r.data.c_id }
                  // }));
                  // window.location.href = window.location.origin + `?t=${new Date().getTime().toString(16)}`;


                } else if (r.data.status == -10) {
                  clearInterval(this.timer);
                  this.qr_over_due = true;
                  this.qr_tip = "二维码已过期，点击重新获取";
                }
              }).catch(e => {
                this.ischeck = false;
              });
            }
          }, 1500);
        }).catch(err => {
          this.qr_tip = "获取二维码失败：" + err.msg;
        });
      }
    },
    postBindWX(wx_openid, wx_unionid) {
      console.log("进来绑定了")
      let row = [{ appid: 'wx5e36e6df39f10d11', openid: wx_openid }];
      this.z_post("api/home/bindWX", {}, {
        params: {
          emp_id: this.accountInfo.emp_id,
          wx_openid: JSON.stringify(row),
          wx_unionid: wx_unionid
        }
      }).then(res => {
        console.log("进来绑定了1")
        this.$message({
          message: "成功!",
          type: "success",
          duration: 1000
        });
      }).catch(res => {
        console.log("进来绑定了2")
        this.$alert("失败!" + res.msg, "提示", {
          confirmButtonText: "确定",
          type: "error"
        });
      });

    },
    open() {
      this.$message('请打开知学习小程序查看详情');
    },
    getsign() {
      this.z_get(
        "api/sign_plan/GetMainSign",
        {
          condition: this.sign,
        },
        { loading: true } //若数据为从后台返回，则让ref为loCationTable 的组件显示加载中的状态图标
      )
        .then(res => {

          this.signDatas = res.data;

        })
        .catch(res => { });

    },
    getcourse() {
      this.z_get(
        "api/project/getMainCourse",
        {
          condition: this.course,
        },
        { loading: true } //若数据为从后台返回，则让ref为loCationTable 的组件显示加载中的状态图标
      )
        .then(res => {
          //console.log(res.data)
          this.courseDatas = res.data;

        })
        .catch(res => { });

    },
    OrdernextDay(day) {
      this.op_date = this.op_date.addDays(day)
      this.$nextTick(() => {
        this.refreshorderData();
      })
    },
    EquipnextDay(day) {
      this.pes_time = this.pes_time.addDays(day)
      this.$nextTick(() => {
        this.refreshequipData();
      })
    },
    EmpnextDay(day) {
      this.record_date = this.record_date.addDays(day)
      this.$nextTick(() => {
        this.refreshemployeeData();
      })
    },
    searchData() {
      //从后台获取数据
      this.z_get(
        "api/competition_team/getMyProject",
        {
          condition: this.model1,
        },
        { loading: true } //若数据为从后台返回，则让ref为loCationTable 的组件显示加载中的状态图标
      )
        .then(res => {
          this.dict = res.dict;
          this.tabelDatas = res.data;

        })
        .catch(res => { });
    },
    changRouter(value) {
      this.$router.push({
        name: value
      });
      this.$root.$emit("on-collapse-click");
    },
    refreshProjectList() {
      this.projectList = [];
      this.z_get(
        "api/order_head/orderMain",
        {
          condition: this.condition
        },
        { loading: this.$refs.projectTable }
      )
        .then(res => {
          this.projectDict = res.dict;
          this.projectList = res.data;
        })
        .catch(res => { });
    },
    handleItemSelectedChange(item, checked) {
      if (checked) {
        if (this.quickSelected.indexOf(item) == -1) {
          this.quickSelected.push(item);
        }
      } else {
        let index = this.quickSelected.indexOf(item);
        if (index != -1) {
          this.quickSelected.splice(index, 1);
        }
      }
    },
    refreshData() {
      this.refreshProjectList();
      this.$nextTick(_ => {
        this.$refs.chart1.echarts.resize()
      })
    },
    refreshorder5day() {
      this.z_get("api/order_plan/GetOrder5dayData", { condition: "" })
        .then(res => {
          this.Order5dayList = res.data;
          for (let index = 0; index < this.Order5dayList.length; index++) {
            this.countlistmap[vm.countList[index].active] = vm.countList[index].sum;
            vm.activetitle.push(vm.countList[index].active);
          }
          //将键值对形式加到array数组里
          vm.countlistArray.push(vm.countlistmap);
          //将行和列分别赋值给chartdata的行和列
          this.LineData.rows = vm.countlistArray;
          this.LineData.columns = vm.activetitle;
        })
        .catch(res => { });
    },
    refreshorderData() {
      this.z_get("api/order_plan/GetOrderTaskRankDatalist", { condition: "", op_date: this.op_date })
        .then(res => {
          this.tableDatas1 = res.data;
        })
        .catch(res => { });
    },
    refreshequipData() {
      this.z_get("api/part_equipment_schedule/GetEquipTaskRankDatalist", { condition: "", pes_time: this.pes_time })
        .then(res => {
          this.tableDatas2 = res.data;
          //console.log(this.tableDatas2, "table2")
        })
        .catch(res => { });
    },
    refreshemployeeData() {
      this.z_get("api/equipment_employee_record/GetEmpRankData", { condition: "", record_date: this.record_date })
        .then(res => {
          this.tableDatas3 = res.data;
          this.dict = res.dict;
        })
        .catch(res => { });
    },
    refreshGame() {
      this.tableData = [];
      this.z_get(
        "api/project/game",
        {
          condition: this.model //左侧为后台参数名，右侧为前端参数名，需配对
        },
        { loading: true } //若数据为从后台返回，则让ref为loCationTable 的组件显示加载中的状态图标

      )
        .then(res => {

          this.tableData = res.data;
          /* console.log(res.data) */

        })
        .catch(res => { });
    },
    getNotification() {
      this.notificationShow = false;
      //判断是否为开发者
      for (var i = 0; i < this.accountInfo.roleinfos.length; i++) {
        if (this.accountInfo.roleinfos[i].role_name == "开发者") {
          this.isDeveloper = true;
        }
      };
      this.notificationData = [];
      this.z_get(
        "api/notification/getNotificationList", { condition: null }
      ).then(res => {
        this.notificationData = res.data;
        this.z_get(
          "api/notification_content/getNotificationContentList", { condition: null }
        ).then(res => {
          let content = res.data;
          for (var i = 0; i < this.notificationData.length; i++) {
            this.notificationData[i]["content"] = [];
            this.notificationData[i]["line"] = 0;
            for (var j = 0; j < content.length; j++) {
              if (this.notificationData[i].notification_id == content[j].notification_id) {
                this.notificationData[i]["content"].push(content[j]);
                if (this.notificationData[i]["line"] < content[j].nc_line) {
                  this.notificationData[i]["line"] = content[j].nc_line;
                }
              }
            }
          }
          this.notificationShow = true;
        }).catch(res => { });
      }).catch(res => { });
    },
    dragstart(index) {
      if (this.sortStatus) {
        this.dragIndex = index;
      }
    },
    dragenter(e, index) {
      if (this.sortStatus) {
        e.preventDefault();
        this.enterIndex = index;
        if (this.timeout != null) {
          clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(() => {
          if (this.dragIndex != index) {
            const source = this.notificationData[this.dragIndex]
            this.notificationData.splice(this.dragIndex, 1)
            this.notificationData.splice(index, 0, source)
            this.dragIndex = index;
          }
        }, 100);
      }
    },
    dragover(e, index) {
      if (this.sortStatus) {
        e.preventDefault();
      }
    },
    //确认改变排序
    editNotificationSort() {
      this.$confirm("您保存当前通知排序?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let data = this.notificationData;
        delete data['line'];
        delete data['content'];
        for (var i = 0; i < data.length; i++) {
          data[i].notification_sequence = i + 1;
          data[i].UpdateColumns = ['notification_sequence']
        }
        this.z_put("api/notification/list", data, { loading: true }).then(res => {
          this.$message({
            message: "保存成功!",
            type: "success",
            duration: 1000
          });
          this.sortStatus = false;
        }).catch(res => {
          this.$alert("保存失败!" + res.msg, "提示", {
            confirmButtonText: "确定",
            type: "error"
          });
        });
      }).catch(() => { });
    },
    //编辑或新增通知
    addOrEdit(type, item) {
      if (item != null && (this.sortStatus || !this.editStatus)) return;   //非编辑、非排序状态下不触发
      this.editVisible = true;
      this.editType = type;
      if (type == 0) {    //编辑状态
        this.$refs.editNotifucation.getNotification(item.notification_id);
      }
      else{    //新增状态
        this.$refs.editNotifucation.clearNotification();
      }
    },
    //点击打开通知网页
    openWindow(link) {
      if (!this.editStatus) {
        window.open(link)
      }
    },
    //修改编辑或排序状态
    changeStatus(type) {
      if (type == 0) {    //编辑
        this.editStatus = true;
        this.sortStatus = false;
      } else if (type == 1) {    //取消编辑
        this.editStatus = false;
      } else if (type == 2) {    //排序
        this.sortStatus = true;
        this.editStatus = false;
      } else if (type == 3) {    //取消排序
        this.sortStatus = false;
      } else {    //添加
        this.editStatus = false;
        this.sortStatus = false;
        this.addOrEdit(1, null)
      }
    }
  },
  mounted() {
    this.getNotification();
    this.refreshGame();
    this.searchData();
    this.getsign();
    this.getcourse()
    this.CurrentAccountInfo = this.accountInfo;

  }
};
</script>

<style scoped>
.pageheader {
  width: 100%;
  margin-bottom: 5px;
}

.left-content {
  display: flex;
  align-items: center;
}

.right-content {
  display: flex;
  align-items: center;
  text-align: center;
  margin-left: auto;
  margin-right: 100px;
  /* margin-right:auto;
  float:right */
}

.msg {
  margin-left: 20px;
  font-size: 18px;
}

.quickAccessDiv {
  width: 250px;
  margin-right: 10px;
  display: flex;
  flex-direction: column;
  position: relative;
  border-radius: 4px;
  background: white;
}

.projectDiv {
  width: 450px;
  height: 100%;
  margin-right: 5px;
}

.projectCard {
  border-radius: 4px;
  padding: 5px;
  background: #d5f1fa;
  border: 1px solid #e9ebed;
  min-height: 150px;
  margin-bottom: 10px;
  cursor: pointer;
}

.projectCard:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.projectCardHead {
  position: relative;
  padding-left: 5px;
  margin-bottom: 10px;
}

.rightTable {
  vertical-align: top;
  margin-left: 10px;
  flex: 1;
}

.rightTable th {
  text-align: left;
}

.rightTable td {
  text-align: left;
}

.arrow-btn {
  cursor: pointer;
  user-select: none;
}

.tip {
  margin-left: 20px;
  font-size: 12px;
  color: rgb(243, 167, 54);
  display: inline;
  text-decoration: underline;
}

.tip:hover {
  color: rgb(245, 127, 30);
}

.title {
  display: inline;
}

.image-div {
  margin-top: 20px;
  text-align: center;
}

.center-png {
  margin: auto;
  top: 1;
  cursor: pointer;
  width: 55px;
}

.qrcode-ct {
  height: 200px;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qr-tip {
  font-size: 15px;
  margin-top: 5px;
}
</style>
<style>
.left-progress .el-progress__text {
  font-size: 24px !important;
}

.projectDiv .el-scrollbar .el-scrollbar__wrap {
  overflow-x: hidden !important;
}

/* 隐藏滚动条 */
::-webkit-scrollbar {
  display: none;
}

/* 其他的滚动条样式，例如滚动条轨道的背景颜色 */
.wrap-scrollbar {
  /* 滚动条轨道的背景颜色 */
  background-color: #eee;

  /* 确保内容不会溢出滚动条 */
  overflow-y: scroll;
}
</style>
